<template>
    <div :class="{ 'modal': true, 'active': showModal }">
        <div class="modal-content">

            <div class="modal-content-header">
                <h3 v-if="customer.id">
                    {{ $t('label.editCustomer') }}
                </h3>
                <h3 v-else>
                    {{ $t('label.addCustomer') }}
                </h3>
                <span class="modal-content-header-close" @click.prevent="close(false)">
	            	<i aria-hidden="true" class="icon icon-close-large"></i>
	            </span>
            </div>

            <div class="modal-content-body">
                <div class="row">
                	<div class="col-lg-4">
                        <avatar-widget v-model="customer.image" :colorpicker="false" :upload="true"></avatar-widget>
                        <div class="row">
                            <div class="col-lg-12">
                                <category-picker v-model="customer.categories"></category-picker>
                            </div>
                        </div>
                    </div>
                    <form action="#" class="form col-lg-8" @submit.prevent>
                        <div class="row">
                            <div class="col-lg-12">
                                <input-widget
                                        :label="$t('label.person_name')"
                                        :placeholder="$t('label.person_name')"
                                        :type="'text'"
                                        v-model="customer.name"
                                        validate="required"
                                        ref="focus"
                                ></input-widget>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12">
                                <input-widget
                                        :label="$t('label.phone')"
                                        :placeholder="$t('label.phone')"
                                        :type="'text'"
                                        v-model="customer.phone"
                                >
                                </input-widget>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12">
                                <label>{{ $t('label.birthday') }}</label>
                                <datepicker class="with-icon"
                                            v-model="customer.birthday"
                                            :disabledDate="disableDate"
                                            :endYear="new Date().getFullYear()"></datepicker>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12">
                                <input-widget
                                        :label="$t('label.email')"
                                        :placeholder="$t('label.email')"
                                        :type="'text'"
                                        validate="email"
                                        v-model="customer.email"
                                >
                                </input-widget>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12">
                                <input-widget
                                        :label="$t('label.note')"
                                        :placeholder="$t('label.note')"
                                        :type="'text'"
                                        v-model="customer.note"
                                >
                                </input-widget>
                            </div>
                        </div>
		                <div class="row">
		                    <div class="col-lg-12">
		                        <div class="button-wrapper-right margin-bottom-20">
		                            <input type="submit" :value="$t('button.save')"
		                                   :class="{'button-full': true, 'loading': loading}" @click.prevent="validate"/>
		                            <span class="button-hollow" @click.prevent="close(false)">{{ $t('button.cancel')
		                                }}</span>
		                        </div>
		                    </div>
		                </div>                        
                    </form>                    
                </div>                
            </div>
        </div>
    </div>
</template>

<script>
  import InputWidget from '@/components/widgets/InputWidget'
  import Datepicker from '@/components/widgets/datepicker/VueDatepickerLocal'
  import CategoryPicker from '@/components/widgets/CategoryPickerWidget'
  import AvatarWidget from '@/components/widgets/AvatarWidget'

  export default {
    name: 'CustomerModal',
    components: {AvatarWidget, InputWidget, Datepicker, CategoryPicker},
    props: ['data', 'show'],
    data () {
      return {
        showModal: false,
        customer: {},
        loading: false
      }
    },
    watch: {
      show (value) {
        this.showModal = value
      },
      data (value) {
        this.customer = value
      }
    },
    methods: {
      validate () {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.save()
          }
        })
      },
      save () {
        this.loading = true

        let formData = this.createFormData()

        if (!this.customer.id) {
          this.$api.post('/v1/customers', formData, {
            'Content-Type': 'multipart/form-data'
          }).then(() => {
            this.close(true)
            this.$events.fire('message-open', {
              type: 'success',
              message: this.$t('message.saveSuccess')
            })
            this.loading = false
          }).catch(() => {
            this.loading = false
            this.$events.fire('message-open', {
              type: 'error',
              message: this.$t('message.saveFailed')
            })
          })
        } else {
          this.$api.post('/v1/customers/' + this.customer.id, formData, {
            'Content-Type': 'multipart/form-data'
          }).then(() => {
            this.close(true)
            this.$events.fire('message-open', {
              type: 'success',
              message: this.$t('message.saveSuccess')
            })
            this.loading = false
          }).catch(() => {
            this.loading = false
            this.$events.fire('message-open', {
              type: 'error',
              message: this.$t('message.saveFailed')
            })
          })
        }
      },
      createFormData () {
        let data = []
        data['name'] = this.customer.name
        data['phone'] = this.customer.phone
        data['email'] = this.customer.email

        if (typeof this.customer.image !== 'string') {
          data['image'] = this.customer.image
        }

        if (this.customer.image === null) {
          data['image_remove'] = 1
          data['image'] = null
        }

        data['note'] = this.customer.note

        if (this.customer.birthday) {
          data['birthday'] = this.$moment(this.customer.birthday).format('YYYY-MM-DD')
        }
        if (this.customer.categories && this.customer.categories.length) {
          let categories = this.extractColumn(this.customer.categories, 'id')
          for (let categoryId in categories) {
            data['categories[' + categoryId + ']'] = categories[categoryId]
          }
        } else {
          data['categories[0]'] = ''
        }

        let formData = new FormData()

        for (let entry in data) {
          if (data[entry] === null || typeof data[entry] === 'undefined') {
            continue
          }
          formData.append(entry, data[entry])
        }

        return formData
      },
      disableDate (time) {
        return time > new Date()
      },
      close (updated) {
        this.showModal = false
        this.customer = {}
        this.$emit('closed', {
          show: this.showModal,
          updated: updated
        })
      },
      extractColumn (arr, column) {
        function reduction (previousValue, currentValue) {
          previousValue.push(currentValue[column])
          return previousValue
        }

        return arr.reduce(reduction, [])
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/pages/Organization/Customers/CustomerModal.vue